import * as React from "react";
import { useFGContext } from "nsitools-react";
import { Prompt } from "react-router";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";

interface IFGRouteDirtyCheckerProps {
  message?: string;
}

export const FGRouteDirtyChecker: React.FunctionComponent<IFGRouteDirtyCheckerProps> = () => {
  const { formik } = useFGContext();
  const { t } = useTl();
  return <Prompt when={formik.dirty} message={t(ETLCodes.FormDirtyRouteChangeMessage)} />;
};
